import React from 'react';
import {
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Button,
    Box, Image, Text, Heading, SimpleGrid, Stat, StatLabel, StatNumber, Tag, Skeleton, Center, Alert, AlertIcon, Divider
} from '@chakra-ui/react';

const InfoItem = ({ label, value, isTag = false }) => (
    <Box>
        <Text fontSize="sm" color="gray.500">{label}</Text>
        {isTag ? (
            <Tag size="md" variant="solid" colorScheme={value === 'active' ? 'green' : 'red'}>{value}</Tag>
        ) : (
            <Text fontWeight="bold">{value || 'N/A'}</Text>
        )}
    </Box>
);

const ModalDetalhesAnuncio = ({ isOpen, onClose, anuncio, isLoading, error }) => {
    const sellerSkuAttribute = anuncio?.attributes?.find(attr => attr.id === 'SELLER_SKU');
    const brandAttribute = anuncio?.attributes?.find(attr => attr.id === 'BRAND');
    const partNumberAttribute = anuncio?.attributes?.find(attr => attr.id === 'PART_NUMBER');

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="4xl" scrollBehavior="inside">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Detalhes do Anúncio</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    {isLoading && (
                        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
                            <Skeleton height="300px" borderRadius="md" />
                            <Box>
                                <Skeleton height="24px" width="80%" mb={4} />
                                <Skeleton height="20px" width="40%" mb={6} />
                                <Skeleton height="60px" width="100%" />
                            </Box>
                        </SimpleGrid>
                    )}
                    {error && !isLoading && (
                        <Alert status="error" borderRadius="md">
                            <AlertIcon />
                            {error}
                        </Alert>
                    )}
                    {anuncio && !isLoading && !error && (
                        <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={6}>
                            <Image
                                src={anuncio.pictures?.[0]?.secure_url || anuncio.pictures?.[0]?.url}
                                alt={anuncio.title}
                                borderRadius="md"
                                objectFit="contain"
                                maxH="400px"
                                fallbackSrc="https://via.placeholder.com/400"
                            />
                            <Box>
                                <Heading as="h3" size="md" mb={2}>{anuncio.title}</Heading>
                                <Text fontSize="2xl" color="green.500" fontWeight="bold" mb={4}>
                                    {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(anuncio.price)}
                                </Text>
                                <SimpleGrid columns={2} spacing={4} mb={4}>
                                    <InfoItem label="SKU" value={sellerSkuAttribute?.value_name} />
                                    <InfoItem label="Marca" value={brandAttribute?.value_name} />
                                    <InfoItem label="Código Global" value={partNumberAttribute?.value_name} />
                                    <InfoItem label="Estoque" value={anuncio.available_quantity} />
                                    <InfoItem label="Condição" value={anuncio.condition === 'new' ? 'Novo' : 'Usado'} />
                                    <InfoItem label="Status" value={anuncio.status} isTag />
                                </SimpleGrid>
                                <Divider my={4} />
                                <Box>
                                    <Text fontSize="sm" color="gray.500" mb={1}>Descrição</Text>
                                    <Box maxH="200px" overflowY="auto" p={2} borderWidth="1px" borderRadius="md" bg="gray.50">
                                       <Text whiteSpace="pre-wrap" fontSize="sm">{anuncio.plain_text_description || 'Descrição não disponível.'}</Text>
                                    </Box>
                                </Box>
                            </Box>
                        </SimpleGrid>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button onClick={onClose}>Fechar</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ModalDetalhesAnuncio;
